import type { SingleSelectDef } from '../types';

interface SingleSelectFieldProps {
  question: SingleSelectDef;
  value: string;
  onChange: (selectedId: string) => void;
}

/**
 * SingleSelectField
 * ラジオボタン風の単一選択フィールド
 * 丸いインジケーター、選択時のボーダーハイライト
 */
export function SingleSelectField({ question, value, onChange }: SingleSelectFieldProps) {
  return (
    <div className="space-y-3">
      {question.options.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={value === option.id}
          onClick={() => onChange(option.id)}
          className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-lg border-2 transition-all cursor-pointer text-left ${
            value === option.id
              ? 'border-[#0052FF] bg-[#F0F5FF]'
              : 'border-[#E5E7EB] bg-white hover:border-[#0052FF]/30'
          }`}
        >
          <div
            className={`flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center ${
              value === option.id
                ? 'border-[#0052FF] bg-[#0052FF]'
                : 'border-[#D1D5DB]'
            }`}
          >
            {value === option.id && (
              <div className="w-2 h-2 rounded-full bg-white" />
            )}
          </div>
          <span className="text-[#111827] text-sm sm:text-base font-medium">
            {option.label}
          </span>
        </button>
      ))}
    </div>
  );
}
